import '../styles/Hero.scss'

const Hero = () => {
    return (
        <div className="Hero" id="home">
            <div className="Hero-Text">
                <h1 className="appear-first">Abdul-Rahime</h1>
                <h1 className="appear-second">Kadri</h1>
                <h1 className="appear-third">Web Developer</h1>
            </div>
        </div>
    )
}

export default Hero;